import { Container } from "reactstrap"
import { ComingSoonTitle } from "../../../Constant"
import { H5, Image } from "../../../AbstractElements"
import CountdownData from "../CountdownData"
import { dynamicImage } from "../../../Service/DynamicImage"

const ComingWithImageBgContainer = () => {
  return (
    <Container fluid className="p-0 m-0">
        <div className="comingsoon comingsoon-bgimg">
          <div className="comingsoon-inner text-center">
            <Image src={dynamicImage("other-images/logo-login.png")} alt="coming soon"/>
            <H5>{ComingSoonTitle}</H5>
            <div className="countdown" id="clockdiv">
            <CountdownData />
            </div>
          </div>
        </div>
      </Container>
  )
}

export default ComingWithImageBgContainer